export const faqData = {
  career_consult_page: [
    {
      title: "Могу ли я продлить сотрудничество ?",
      desc: "Да, конечно. Постоянным клиентам мы предлагаем персонализированные условия."
    },
    {
      title: "Можно оплатить услугу частями ?",
      desc: "Да, вы можете оплатить услугу двумя частями: половину при бронировании, а вторую часть после встречи."
    },
    {
      title: "Возможен ли возврат средств ?",
      desc: "Если вы сообщите об отмене встречи за 1 день, то мы вернем средства в полном объеме."
    },
    {
      title: "Как можно подготовиться к встрече ?",
      desc: "После бронирования встречи на сайте, с вами свяжется менеджер и направит всю информацию для подготовки."
    },
  ],
  cv_ready_page: [
    {
      title: "Могу ли я продлить сотрудничество ?",
      desc: "Да, конечно. Постоянным клиентам мы предлагаем персонализированные условия."
    },
    {
      title: "Можно оплатить услугу частями ?",
      desc: "Да, вы можете оплатить услугу двумя частями: половину при бронировании, а вторую часть после встречи."
    },
    {
      title: "Возможен ли возврат средств ?",
      desc: "Если вы сообщите об отмене встречи за 1 день, то мы вернем средства в полном объеме."
    },
    {
      title: "Как можно подготовиться к встрече ?",
      desc: "После бронирования встречи на сайте, с вами свяжется менеджер и направит всю информацию для подготовки."
    },
  ],
  search_support_page: [
    {
      title: "Как можно узнать подробней об услуге ?",
      desc: "Оставьте заявку на сайте, менеджер свяжется с вами и назначит встречу-знакомство, где подробно разберем ваш кейс и расскажем о прогнозах поиска."
    },
    {
      title: "Можно оплатить услугу частями ?",
      desc: "Да, вы можете оплатить услугу несколькими частями. Мы готовы согласовать с вами удобный формат."
    },
    {
      title: "Как юридически оформлена работа ?",
      desc: "Мы заключаем договор, где прописаны все условия и критерии выполнения услуги."
    },
  ],
  probation_support_page: [
    {
      title: "Как можно узнать подробней об услуге ?",
      desc: "Оставьте заявку на сайте, менеджер свяжется с вами и назначит встречу-знакомство, где подробно разберем ваш кейс и расскажем о прогнозах поиска."
    },
    {
      title: "Можно оплатить услугу частями ?",
      desc: "Да, вы можете оплатить услугу несколькими частями. Мы готовы согласовать с вами удобный формат."
    },
    {
      title: "Как юридически оформлена работа ?",
      desc: "Мы заключаем договор, где прописаны все условия и критерии выполнения услуги."
    },
    {
      title: "Как можно подготовиться к встрече ?",
      desc: "После бронирования встречи на сайте, с вами свяжется менеджер и направит всю информацию для подготовки."
    },
  ],
  vacancies_page: [
    {
      title: "Как можно узнать подробней об услуге ?",
      desc: "Оставьте заявку на сайте, менеджер свяжется с вами и назначит встречу-знакомство, где подробно разберем ваш кейс и расскажем о прогнозах поиска."
    },
    {
      title: "Могу ли я продлить сотрудничество ?",
      desc: "Да, конечно. Постоянным клиентам мы предлагаем персонализированные условия."
    },
    {
      title: "Как юридически оформлена работа ?",
      desc: "Мы заключаем договор, где прописаны все условия и критерии выполнения услуги."
    },
  ],
  talkitout_page: [
    {
      title: "Могу ли я оплатить услугу частями ?",
      desc: "Да, вы можете оплатить услугу двумя частями: половину при бронировании, а вторую часть после встречи."
    },
    {
      title: "Какая экспертиза в психологии у эксперта ?",
      desc: "Любовь Прохорова магистр психологических наук и коучинга, ее диссертация была посвящена проблемам эмоционального выгорания сотрудников ИТ индустрии."
    },
    {
      title: "Возможен ли возврат средств ?",
      desc: "Если вы сообщите об отмене встречи за 1 день, то мы вернем средства в полном объеме."
    },
    {
      title: "Как можно подготовиться к встрече ?",
      desc: "После бронирования встречи на сайте, с вами свяжется менеджер и направит всю информацию для подготовки."
    }
  ],
  it_hiring_page: [
    {
      title: "Какое среднее время закрытия позиций ?",
      desc: "Среднее время закрытие позиций от 14 дней до 35 дней в зависимости от сложности позиции."
    },
    {
      title: "Вы работаете только с ИТ позициями ?",
      desc: "Нет, мы со всеми позициями, но больший профиль у нас в ведении ИТ/Диджитал вакансий."
    },
    {
      title: "Как юридически оформлена работа ?",
      desc: "Мы заключаем договор, где прописаны все условия и критерии выполнения услуги."
    },
  ],
  it_training_page: [
    {
      title: "На каких позициях я могу работать ?",
      desc: "После обучения вы можете работать сорсером, рекрутером и HR-менеджером в ИТ индустрии."
    },
    {
      title: "Можно совмещать работу с обучением ?",
      desc: "Да, более 30 наших выпускников совмещали работу с обучением и с личными делами. У вас не будет трудностей, чтобы все комфортно успеть."
    },
    {
      title: "Возможен ли возврат средств ?",
      desc: "Да, он прописан в договоре."
    },
  ],
  linkedin_boost_page: [
    {
      title: "Когда появятся первые результаты?",
      desc: "Первые изменения в просмотрах и откликах обычно видны в течение 3–4 недель.",
    },
    {
      title: "Вы пишете контент или я сам?",
      desc: "В зависимости от тарифа: либо полностью берём на себя, либо работаем совместно.",
    },
    {
      title: "Подходит ли услуга для международного рынка?",
      desc: "Да, мы работаем с англоязычными и международными аудиториями.",
    },
    {
      title: "Можно ли масштабировать работу дальше?",
      desc: "Да, LinkedIn‑профиль легко интегрируется в личный бренд и маркетинг в целом.",
    },
  ]
}
